const cleanStringFromInlineStyles = (text: string) =>
	text?.replaceAll(/style="[^"]*"/g, '');

export const parseHTML = (text?: string) => {
	if (!text) return '';

	return (
		<span
			dangerouslySetInnerHTML={{ __html: cleanStringFromInlineStyles(text) }}
		/>
	);
};
